module.exports = __webpack_public_path__ + "static/media/money_training.075b884d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/money_training.svg
// module id = 2428
// module chunks = 7